import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { assets } from '../lib/assets';
import { useAuth } from '../lib/auth';

export default function Navbar({ onGift }) {
  const [scrolled, setScrolled] = React.useState(false);
  const { user, login } = useAuth();
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: 'About', id: 'about' },
    { label: 'Journey', id: 'journey' },
    { label: 'Plans', id: 'pricing' },
    { label: 'Founders', id: 'founders' },
    { label: 'Trust', id: 'trust' },
  ];

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? 'backdrop-blur-xl bg-brand-bg border-b border-brand-line/70' : 'bg-brand-bg'
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center group" data-testid="brand-logo">
          <img
            src={assets.logo}
            alt="Pallavit — Gift a Tree. Grow a Legacy."
            className="h-14 md:h-16 w-auto object-contain"
            style={{ mixBlendMode: 'multiply' }}
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="text-sm tracking-wide transition-colors text-brand-ink2 hover:text-brand-forest"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Link
              to="/garden"
              data-testid="nav-garden-link"
              className="hidden sm:inline-flex items-center gap-2 text-sm text-brand-ink2 hover:text-brand-forest"
            >
              {user.picture && (
                <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-brand-line object-cover" />
              )}
              <span className="hidden md:inline">My garden</span>
            </Link>
          ) : (
            <button
              onClick={login}
              data-testid="nav-signin-button"
              className="hidden sm:inline-flex text-sm tracking-wide text-brand-ink2 hover:text-brand-forest"
            >
              Sign in
            </button>
          )}
          <button
            onClick={onGift}
            data-testid="nav-gift-tree-button"
            className="rounded-full px-5 py-2.5 text-sm font-medium tracking-wide transition-all hover:-translate-y-[1px] bg-brand-forest text-brand-bg hover:bg-brand-ink"
          >
            Adopt a Tree
          </button>
        </div>
      </div>
    </motion.header>
  );
}
